<template>
  <swiper
    :modules="modules"
    :slides-per-view="'auto'"
    :looped-slides="list.length"
    :space-between="24"
    :speed="4000"
    :loop="true"
    :autoplay="{ delay: 0, disableOnInteraction: false, reverseDirection: reverse }"
    navigation
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <figure><img :src="item.pic" alt="photo"></figure>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  width: auto;
}
figure{
  padding: 2rem 3.2rem;
  border: module.$border 1px solid;
}
img{
  width: 10rem;
  height: 3.2rem;
  object-fit: contain;
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const breakpoints = {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
      769: {
        spaceBetween: 10,
      },
    };

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
      breakpoints,
    }
  },
}
</script>
